import React from "react"
import styles from "./styles.css"
import iconMinus from "../../../../../assets/svg/fixed-voice-minus.svg"
import iconPlus from "../../../../../assets/svg/fixed-voice-plus.svg"
import PropTypes from "prop-types"
import { handlePhone } from "services/utils/mask"

const PortedNumbers = ({ formik, limit }) => {
  const {
    values,
    errors,
    setFieldValue,
    setFieldTouched,
    handleBlur,
    touched,
    setValues
  } = formik

  values.qnt = values.phonesPortability.length !== values.qnt ? 1 : values.qnt

  const addPhoneNumber = () => {
    setValues({
      ...values,
      phonesPortability: [...values.phonesPortability, { phone: "" }]
    })
  }

  const removePhoneNumber = () => {
    if (values.phonesPortability.length <= 1) {
      return
    }

    const updatedPhone = [...values.phonesPortability]
    updatedPhone.splice(values.phonesPortability.length - 1, 1)

    formik.setFieldTouched("phonesPortability", updatedPhone)

    formik.setValues({
      ...formik.values,
      phonesPortability: updatedPhone
    })
  }

  const onControlNumber = (control) => {
    const currentAmount = values.qnt
    let updatedAmount

    switch (control) {
      case "minus":
        if (currentAmount > 1) {
          removePhoneNumber()
          updatedAmount = parseInt(currentAmount, 10) - 1
        } else {
          updatedAmount = parseInt(currentAmount, 10)
        }
        break
      case "plus":
        if (currentAmount < limit) {
          addPhoneNumber()
          updatedAmount = parseInt(currentAmount, 10) + 1
        } else {
          updatedAmount = parseInt(currentAmount, 10)
        }
        break
      default:
        updatedAmount = parseInt(currentAmount, 10)
        break
    }

    if (updatedAmount < 1) {
      return
    }

    setFieldValue("qnt", updatedAmount, true)
    setFieldTouched("qnt", true)
  }

  const handleInputPhone = (e) => {
    const { name, formattedValue } = handlePhone(e)
    const target = { name, value: formattedValue }
    handleChange(target)
  }

  const handleChange = ({ name, value }) => {
    setFieldValue(name, value, true)
    const updatedErrors = { ...errors }

    if (updatedErrors[name]) {
      delete updatedErrors[name]
      formik.setErrors(updatedErrors)
    }
  }

  return (
    <div>
      <div className={`${styles.line} ${styles.input_ported}`}>
        <img src={iconMinus}
             alt={"icon minus"}
             onClick={() => onControlNumber("minus")}
        />
        <input
          id="qnt"
          name="qnt"
          type="number"
          className={styles.amount_numbers_ported}
          placeholder="0"
          value={values.qnt}
          onBlur={handleBlur}
          tabIndex={8}
          readOnly={true}
        />
        <img src={iconPlus}
             alt={"icon plus"}
             onClick={() => onControlNumber("plus")}
        />
      </div>
      <div>
        <div>
          <p className={`${styles.text_input} ${styles.text_input_ported}`}>
            Insira o número do cliente
          </p>
        </div>
        { values.phonesPortability.map((tel, index) => (
          <div key={index} className={`${styles.line} ${styles.column} ${styles.display_flow}`}>
            <div>
              <input
                id={`phonesPortability[${index}]`}
                name={`phonesPortability[${index}].phone`}
                type="tel"
                placeholder="(00) 00000-0000"
                className={`${
                  touched.phonesPortability &&
                  touched.phonesPortability[index] &&
                  errors[`phonesPortability[${index}].phone`] &&
                  styles.focus_error
                }`}
                onChange={(e) => handleInputPhone(e)}
                value={tel.phone}
                onBlur={handleBlur}
                tabIndex={9}
              />
            </div>

            <div>
              {touched.phonesPortability &&
                touched.phonesPortability[index] &&
                errors[`phonesPortability[${index}].phone`] && (
                  <div className={styles.error}>
                    {errors[`phonesPortability[${index}].phone`]}
                  </div>
                )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

PortedNumbers.propTypes = {
  formik: PropTypes.object.isRequired,
  limit: PropTypes.number.isRequired
}

export default PortedNumbers



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/NewSale/components/PortedNumber.js